<script setup>
import { DrawerOverlay } from "vaul-vue";
import { computed } from "vue";
import { cn } from "@/Utils/cn";

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  forceMount: { type: Boolean, required: false },
  class: { type: null, required: false },
});

const delegatedProps = computed(() => {
  /* eslint-disable-next-line */
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <DrawerOverlay
    v-bind="delegatedProps"
    :class="cn('fixed inset-0 z-50 bg-black/50', props.class)"
  />
</template>
